module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/4-e2126d6cfa802711dea0db3002fbaab4.svg";